module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1530-e2005b3a3a497b71f1d0d4cbefae6d2d.png";